import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import useLoading from "components/atoms/loading/useLoading";

import FormInput from "components/molecules/FormInput";
import AbstractModalFooter from "components/page/modal/AbstractModalFooter";

import { usePaymentCouponRegister } from "hooks/queries/usePayment";

import { genericEnterKeyDown } from "utils/validation";

const Container = styled.div`
    width: 100%;
`;

function CouponRegisterModal(props) {
    const { exitModal } = props;

    const { setLoading } = useLoading();

    const inputRef = useRef(null);
    const couponRegister = usePaymentCouponRegister();
    const [couponCode, setCouponCode] = useState("");

    const handleApply = () => {
        setLoading(true);
        couponRegister.mutate(
            { number: couponCode },
            {
                onSuccess: () => {
                    setCouponCode("");
                    exitModal();
                    setLoading(false);
                },
                onError: (error) => {
                    setLoading(false);
                },
            },
        );
    };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    return (
        <Container>
            <FormInput
                labelDp="none"
                placeholder="Coupon Code"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                onKeyDown={(e) => {
                    genericEnterKeyDown(e, () => {
                        handleApply();
                    });
                }}
                ref={inputRef}
            />
            <AbstractModalFooter
                leftBtnText={"Cancel"}
                rightBtnText={"Add"}
                leftOnClick={props.exitModal}
                rightOnClick={() => {
                    handleApply();
                }}
            />
        </Container>
    );
}

export default CouponRegisterModal;
